
const TablePagination = ({ table, totalCount }) => {
  return (
    <>
      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-700 dark:text-gray-400 hidden lg:inline">
          Showing {table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1} to{' '}
          {Math.min(
            (table.getState().pagination.pageIndex + 1) * table.getState().pagination.pageSize,
            totalCount
          )}{' '}
          of {totalCount} results
        </span>
        <div className="flex items-center space-x-1">
          <span className="text-sm text-gray-700 dark:text-gray-400 hidden md:inline">Show</span>
          <select
            value={table.getState().pagination.pageSize}
            onChange={e => table.setPageSize(Number(e.target.value))}
            className="px-3 py-1 text-sm border border-gray-300 rounded bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-white"
          >
            {(() => {
              const pageSizeOptions = [10, 25, 50, 75, 100];
              const availableOptions = pageSizeOptions.filter(size => size <= totalCount);
              // Always include at least one option even if totalCount is less than 25
              if (availableOptions.length === 0 && totalCount > 0) {
                availableOptions.push(Math.min(25, totalCount));
              }
              // If totalCount is less than 100 but greater than the largest available option, add totalCount as an option
              if (totalCount < 100 && totalCount > Math.max(...availableOptions, 0)) {
                availableOptions.push(totalCount);
              }
              return availableOptions.map(pageSize => (
                <option key={pageSize} value={pageSize}>
                  {pageSize}
                </option>
              ));
            })()}
          </select>
          <span className="text-sm text-gray-700 dark:text-gray-400 hidden md:inline">per page</span>
        </div>
      </div>

      <div className="flex items-center space-x-2">
        <button
          onClick={() => table.setPageIndex(0)}
          disabled={!table.getCanPreviousPage()}
          className="px-3 py-1 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {'<<'}
        </button>
        <button
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
          className="px-3 py-1 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {'<'}
        </button>

        <span className="flex items-center space-x-2">
          <span className="text-sm text-gray-700 dark:text-gray-400 hidden md:inline">Page</span>
          <strong className="text-sm text-gray-900 dark:text-gray-100">
            <span className="hidden md:inline">{table.getState().pagination.pageIndex + 1} of {table.getPageCount()}</span>
            <span className="md:hidden text-xs">{table.getState().pagination.pageIndex + 1} / {table.getPageCount()}</span>
          </strong>
        </span>

        <button
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
          className="px-3 py-1 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {'>'}
        </button>
        <button
          onClick={() => table.setPageIndex(table.getPageCount() - 1)}
          disabled={!table.getCanNextPage()}
          className="px-3 py-1 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {'>>'}
        </button>
      </div>
    </>
  );
};

export default TablePagination;